<script lang="ts">
    
    import { getContext } from "svelte";
    import type { Board } from "../../Model/Board";
    import type { Cell } from "../../Model/Cell";
    import type { Game } from "../../Model/Game";
    import { boardsService } from "../../Services";
    import Mark from "./Mark.svelte";

    export let cell: Cell | null;

    const getGame: () => Game = getContext('getGame');
    const getBoard: () => Board = getContext('getBoard');
    const checked = cell?.checked;
    const fontSizeFactor = 0.65;

    let cellElement: HTMLElement;
    let cellWidth = 20;

    $: if ($checked) {
        onChecked();
    }

    $: fontSize = cellWidth * fontSizeFactor;

    function onClick(): void {
        if (!cell || cell.isChecked) {
            return;
        }

        const game = getGame();

        if (!game.hasNumber(cell.number)) {
            //TODO: Animación de número no ha salido
            return;
        }

        boardsService.checkCell(getBoard().id, cell.number);
    }

    function onChecked(): void {
        if (!cellElement) {
            return;
        }
        const clon = cellElement.cloneNode(true) as HTMLElement;
        const rect = cellElement.getBoundingClientRect();
        clon.style.top = `${rect.top}px`;
        clon.style.left = `${rect.left}px`;
        clon.style.width = `${rect.width}px`;
        clon.style.height = `${rect.height}px`;
        clon.classList.add('cell-check-clon');
        document.body.append(clon);
        window.setTimeout(() => clon.remove(), 1000);
    }

</script>

{#if cell}
    <div
        bind:this={cellElement}
        bind:clientWidth={cellWidth}
        class="cell"
        class:checked={$checked}
        on:click={onClick}
        style="font-size: {fontSize}px;">
        {#if $checked}
            <Mark {cell} />
        {:else}
            {cell.number}
        {/if}
    </div>
{:else}
    <div class="cell empty" />
{/if}

<style lang="scss">

    .cell {
        background-color: #fff;
        color: var(--color-primary);
        font-family: BingoNumber;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 1.2vmax;

        &.empty {
            opacity: 0.5;
        }

        &.checked {
            background-color: var(--color-secondary);
        }
    }

    :global(.cell-check-clon) {
        position: fixed !important;
        z-index: 900;
        pointer-events: none;
        touch-action: none;
        animation-name: cell-check;
        animation-duration: 1s;
        animation-fill-mode: forwards;
        animation-iteration-count: 200ms;
    }

    @keyframes cell-check {
        0% {
            transform: scale(1);
            opacity: 1;
        }
        100% {
            transform: scale(2);
            opacity: 0;
        }
    }

</style>
